import { MapContext } from 'contexts/MapContext';
import * as Styled from './styles';
import * as RiIcons from 'react-icons/ri';
import React, { useContext, useMemo, useEffect, useState } from 'react';
import { useLayers } from 'hooks/useLayers';

import VectorLayer from 'ol/layer/Vector';
import { ToolBox } from 'screens/Dashboard/components/SideBar/ToolBox';
import { BaseSelect } from 'components/BaseSelect';

function getName(str: string) {
  const key = 'p3m:';
  const index = str?.indexOf(key);
  return index !== -1 ? 'p3m:' + str?.slice(index + key.length) : '';
}

function getLayerId(layer: any): string {
  const props = layer?.getProperties?.() ?? {};

  if (props.layertitle) return String(props.layertitle);
  if (props.uuid) return String(props.uuid);

  return '';
}

export function ClipLayersMenu() {
  const { getLayerAttritubeByName } = useLayers();

  const {
    map,
    clipInputLayer,
    clipMaskLayer,
    isClipping,
    handleSetClipInputLayer,
    handleSetClipMaskLayer,
    handleApplyClipLayers,
  } = useContext(MapContext);

  const [layersVersion, setLayersVersion] = useState(0);

  useEffect(() => {
    if (!map) return;

    const layers = map.getLayers();

    const onAdd = () => {
      setLayersVersion(v => v + 1);
    };

    layers.on('add', onAdd);

    return () => {
      layers.un('add', onAdd);
    };
  }, [map]);

  const vectorLayers = useMemo(() => {
    if (!map) return [];

    return map
      .getLayers()
      .getArray()
      .filter((layer: any) => {
        if (!(layer instanceof VectorLayer)) return false;

        const props = layer?.getProperties?.() ?? {};
        return !!(props.layertitle || props.uuid);
      });
  }, [map, layersVersion]);

  const selectedInputId = clipInputLayer ? getLayerId(clipInputLayer) : '';
  const selectedMaskId = clipMaskLayer ? getLayerId(clipMaskLayer) : '';

  function getLayerLabel(layer: any) {
    const id = getLayerId(layer);
    const meta = getLayerAttritubeByName(getName(id))?.layertitle || id;
    return meta.replace(/\.(kml|geojson|zip|shp)$/i, '');
  }

  const canApplyClip = !!clipInputLayer && !!clipMaskLayer && !isClipping;

  return (
    <ToolBox
      header={
        <>
          <RiIcons.RiCropLine />
          <span>Clip de Camada</span>
        </>
      }
    >
      <BaseSelect
        label='Camada de entrada'
        value={selectedInputId || 'disable'}
        onChange={handleSetClipInputLayer}
        placeholder={'Selecione a camada'}
        options={vectorLayers.map(l => ({
          label: getLayerLabel(l),
          value: getLayerId(l),
        }))}
      />

      <BaseSelect
        label='Camada limite (faca)'
        value={selectedMaskId || 'disable'}
        onChange={handleSetClipMaskLayer}
        placeholder={'Selecione a camada'}
        options={vectorLayers.map(l => ({
          label: getLayerLabel(l),
          value: getLayerId(l),
        }))}
      />

      <Styled.ApplyButton
        onClick={handleApplyClipLayers}
        disabled={!canApplyClip}
      >
        {isClipping ? 'Processando...' : 'Aplicar clip'}
      </Styled.ApplyButton>
    </ToolBox>
  );
}